// extracted by css-extract-rspack-plugin
var _1 = "csAQ8kpHlZkwAillZjHRAg--";
var _2 = "HO49eOKY0mk1x3-o06t4lw--";
var _3 = "tehjadluwzkf4jsyeUx8fw--";
var _4 = "D-i6OWHMRVhyqzS--oagpg--";
var _5 = "ba-69jvF1q2MShg8aeqYrw--";
var _6 = "gDuU00FY-zq8zjIS1o06-g--";
export { _1 as "badgeWrapper", _2 as "button", _3 as "buttonIconFill", _4 as "iconHoverBackOffice", _5 as "iconHoverNormal", _6 as "lastIcon" }
